import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<path\n  d=\"M22 12L2 4L4 12L2 20L22 12ZM5.81 13H14.11L4.88 16.69L5.81 13ZM14.11 11H5.81L4.89 7.31L14.11 11Z\"\n  fill={{this.defaultColor}}\n></path>", {
  moduleName: "@dashboard/shared-ui/components/svgs/send.hbs"
});